import { Input } from "../form/atoms/TextualInput";
import { styled } from "../theme";
export const FullWidth = styled.div `
  width: 100%;
`;
export const SelectedWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.darkBlue10};
`;
export const SelectedOption = styled.div `
  background-color: ${({ theme }) => theme.color.darkBlue100};
  padding: 12px 15px;
  border-radius: 20px;
  color: ${({ theme }) => theme.color.white};
  margin: 2px 10px 2px 2px;
  display: flex;
  align-items: center;
`;
export const StyledInput = styled(Input) `
  flex: 1;
  width: auto;
  min-width: 250px;
  display: flex;
  background-color: transparent;
  font-size: 16px;
`;
export const OptionsWrapper = styled.div `
  margin-top: 3px;
  background-color: white;
  box-shadow: 0 1px 4px 0 rgba(143, 142, 148, 0.3);
  border-style: solid;
  border-width: 0.5px;
  max-height: 230px;
  overflow: auto;
`;
export const Option = styled.div `
  cursor: pointer;
  padding: 20px 20px;
  border-bottom: 0.5px solid rgba(143, 142, 148, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background-color: ${({ theme }) => theme.color.gray100};
  }
`;
export const EmptyMessage = styled(Option) `
  cursor: default;
  &:hover {
    background-color: transparent;
  }
`;
export const CloseTag = styled.span `
  cursor: pointer;
  margin-left: 10px;
`;
